export default "__VITE_ASSET__BNxM71yK__"